var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "maxHeight",
          rawName: "v-maxHeight",
          value: _vm.offset,
          expression: "offset"
        }
      ],
      ref: "listColumnsContainer",
      class: ["list-columns", _vm.disabled && "is-disabled"],
      attrs: { "data-testid": "list-columns" }
    },
    _vm._l(_vm.listItems, function(item) {
      return _c(
        "div",
        { key: item[_vm.keyProp], staticClass: "list-columns__item" },
        [_vm._t("body", null, { item: item })],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }